import { ellipsis } from "@/common/style/commonStyle";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useAccountStyle = makeStyles({
	container: {
		minWidth: "10rem",
		maxWidth: "16rem",
		position: "relative",
		...shorthands.padding(tokens.spacingVerticalL, 0),
	},
	button: {
		height: "2rem",
		flexShrink: 0,
		justifyContent: "flex-start",
		fontWeight: tokens.fontWeightRegular,
	},
	queuesLabel: {
		...shorthands.padding(0, tokens.spacingHorizontalL),
	},
	multiCheckbox: {
		overflowY: "auto",

		...shorthands.padding(0, tokens.spacingHorizontalS),
		"@media (max-height: 768px)": {
			maxHeight: "100px",
		},
		"@media (min-height: 769px)": {
			maxHeight: "250px",
		},
	},
	multiCheckboxItem: {
		"&>label": {
			...ellipsis(),
		},
		minHeight: "max-content",
	},
	workloadMenuTrigger: {
		...shorthands.padding("0px", "20px", "0px", "14px"),
		color: tokens.colorNeutralForeground3,
	},
	versionText: {
		fontSize: "12px",
	},
	isNotJoinedColor: {
		color: tokens.colorPaletteRedBackground3,
	},
});
